module.exports = __webpack_public_path__ + "static/img/swisscontactlogo.512b549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swisscontactlogo.png
// module id = v8Yv
// module chunks = 1